export default __webpack_public_path__ + "static/media/sch5_w1024.d7f36789.jpg";